<template>
  <div class="fillIn">
    <Header :companyInfo="comnpany_info" />
    <div class="form common">
      <!-- <div class="title">
        <span class="leftBack"></span>
        <span class="text">请根据以下提示填写申报基本资料</span>
        <span class="rightBack"></span>
      </div> -->
      <div class="title">
        <span class="leftBack"></span>
        <span class="leftBack2"></span>
        <span class="text">请根据以下提示填写申报基本资料</span>
        <span class="rightBack2"></span>
        <span class="rightBack"></span>
      </div>
      <div class="formList">
        <div class="list">
          <span class="bitian">*</span>
          <span class="formTitle">身份证号：</span>
          <input
            @input="changShowEyes()"
            v-model="idcard"
            :type="passwordShow ? 'text' : 'password'"
            autocomplete="off"
            placeholder="请输入法定代表人身份证号"
          />
          <span class="danwei">
            <i
              v-if="showEyes"
              class="icon"
              :style="[
                {
                  background: `url(${
                    passwordShow ? require('../assets/images/yincang.png') : require('../assets/images/xianshi.png')
                  }) 0% 0% / 100% 100%`,
                },
              ]"
              @click="passwordShow = !passwordShow"
            ></i>
          </span>
        </div>
        <div class="list">
          <span class="bitian">*</span>
          <span class="formTitle">手机号码：</span>
          <input placeholder="请填写工商登记手机号" v-model="phone" type="number" />
        </div>
        <div class="list">
          <span class="formTitle">员工数量：</span>
          <input placeholder="请填写员工数量" v-model="cysum" type="number" />
          <span class="danwei">人</span>
        </div>
        <div class="list">
          <span class="formTitle">年营业额：</span>
          <input placeholder="填写公司年营业额（万元）" v-model="yearmony" type="number" />
          <span class="danwei">万</span>
        </div>
        <div class="list">
          <span class="formTitle">年纳税额：</span>
          <input placeholder="填写公司年纳税额（万元）" v-model="outmony" type="number" />
          <span class="danwei">万</span>
        </div>
      </div>
      <div v-throttle="[Submit, `click`, 2000]" class="btn">已填好，下一步</div>
      <div class="note">(*注意:以上填写信息仅用于年报申报代办使用，无其他用途)</div>
    </div>
    <contact>
      <div class="contactTitle">
        <span>填写</span>
        <span>遇到困难</span>
        <span>请点击下方按钮 专业人员将为您服务</span>
      </div>
    </contact>
    <Footer />
    <kefu />
  </div>
</template>
<script>
import footer from "../components/footer.vue";
import contact from "../components/contact.vue";
import Header from "../components/header2.vue";
import kefu from "../components/kefu.vue";
import { get_company_fill, in_company_fill } from "../api/request";
import { Toast } from "mint-ui";
export default {
  name: "", //
  data() {
    return {
      creditcoder: "", //统一社会信用代码
      fill_id: "",
      idcard: "",
      phone: "",
      zcmony: 0,
      cysum: "",
      yearmony: "",
      outmony: "",
      radio1: 0,
      radio2: 0,
      radio3: 0,
      radio4: 0,
      radio5: 0,
      id: "",
      passwordShow: false,
      showEyes: false,
      regnumber: "",
      random: "",
      comnpany_info: {},
    };
  },
  components: {
    Footer: footer,
    contact,
    Header,
    kefu,
  },
  props: {},
  methods: {
    Submit() {
      let reg =
        /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/;
      let reg2 =
        /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/;
      if (!reg.test(this.idcard)) {
        Toast("请正确填写18位身份证号");
        return;
      }
      if (!reg2.test(this.phone)) {
        Toast("请正确填写11位数字的手机号");
        return;
      }
      this.in_company_fill();
    },
    isWeiXin() {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    },
    in_company_fill() {
      in_company_fill({
        random: this.random,
        fill_id: this.fill_id,
        e_id: this.id,
        creditcoder: this.creditcoder,
        idcard: this.idcard.toUpperCase(),
        phone: this.phone,
        zcmony: this.zcmony,
        cysum: this.cysum,
        yearmony: this.yearmony,
        outmony: this.outmony,
        radio1: this.radio1,
        radio2: this.radio2,
        radio3: this.radio3,
        radio4: this.radio4,
        radio5: this.radio5,
      }).then((res) => {
        if (res.code == 200) {
          if (this.isWeiXin()) {
            const local = "https://" + window.location.host + "/payment";
            window.location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6bacf913e46598c0&redirect_uri=" +
              encodeURIComponent(local) +
              "&response_type=code&scope=snsapi_base&state=" +
              this.random +
              "#wechat_redirect";
          } else {
            this.$router.push({ path: "/payment", query: { state: this.random } });
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    get_company_fill() {
      get_company_fill({
        id: this.id,
        random: this.random,
      }).then((res) => {
        if (res.data.creditcoder == "") {
          this.creditcoder = res.data.regnumber;
        } else {
          this.creditcoder = res.data.creditcoder;
        }
        this.phone = res.data.phone;
        if (res.data.idcard) {
          this.fill_id = res.data.fill_id;
          this.idcard = res.data.idcard;
          this.cysum = res.data.cysum;
          this.yearmony = res.data.yearmony;
          this.outmony = res.data.outmony;
          this.showEyes = true;
        } else {
          this.showEyes = false;
        }
      });
    },
    changShowEyes() {
      if (this.idcard == "") {
        this.showEyes = false;
      } else {
        this.showEyes = true;
      }
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.random = this.$route.query.random;
    this.comnpany_info = JSON.parse(this.$route.query.comnpany_info);
    this.get_company_fill();
  },
  mounted() {},
  destroyed() {},
};
</script>
<style lang="less" scoped>
/* 隐藏输入密码框后的内容 */
input[type="password"]::-webkit-credentials-cramble-button {
  appearance: none;
}

input[type="password"]::-ms-reveal {
  display: none;
}

input[type="password"]::-ms-clear {
  display: none;
}
/* by wdl */
.fillIn {
  background: #ececec;
  .common {
    background: #fff;
    box-shadow: 0px 2px 5px 0px #a7d7fb;
    width: 359px;
    margin: 10px auto 0;
    // border-radius: 5px;
    box-sizing: border-box;
    padding: 10px 10px 15px;
  }
  .form {
    padding-top: 4px;
    // .title {
    //   display: flex;
    //   align-items: center;
    //   justify-content: space-between;
    //   margin-bottom: 30px;
    //   width: calc(100% + 20px);
    //   margin-left: -10px;
    //   letter-spacing: 2px;
    //   .rightBack,
    //   .leftBack {
    //     display: inline-block;
    //     width: 23px;
    //     height: 23px;
    //     background: url(../assets/images/details.png);
    //     background-size: 100% 100%;
    //   }
    //   .text {
    //     font-size: 19px;
    //     color: #df1a1a;
    //     font-weight: bolder;
    //     white-space: nowrap;
    //     margin: 0 5px;
    //   }
    //   .leftBack {
    //     transform: rotate(180deg);
    //   }
    // }
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% + 20px);
      margin-left: -10px;
      letter-spacing: 1px;

      .rightBack,
      .leftBack {
        display: inline-block;
        width: 20px;
        height: 34px;
        background-size: 100% 100%;
        background: #116bff;
      }
      .leftBack2,
      .rightBack2 {
        display: inline-block;
        width: 5px;
        height: 34px;
        background-size: 100% 100%;
        background: #116bff;
      }
      .leftBack,
      .rightBack2 {
        margin-right: 4px;
      }
      .text {
        font-size: 19px;
        color: #df1a1a;
        font-weight: bolder;
        white-space: nowrap;
        margin: 0 5px;
        // font-family:Bold;
      }
    }
    .formList {
      padding: 0 12px;
      .list {
        margin-top: 30px;
        position: relative;
        padding-left: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .bitian {
          color: #df1a1a;
          position: absolute;
          left: 0;
        }
        .formTitle {
          font-size: 16px;
          font-weight: bolder;
          letter-spacing: 2px;
          white-space: nowrap;
        }
        input {
          height: 25px;
          flex: 1;
          padding-right: 30px;
          font-size: 14px;
          text-align: center;
          color: #4e4e4e;
          // letter-spacing: 1px;
        }
        .danwei {
          position: absolute;
          right: 10px;
          .icon {
            display: inline-block;
            width: 20px;
            height: 20px;
          }
        }
      }
      .list:nth-of-type(1){
        margin-top: 23px;
      }
    }
    .btn {
      width: 302px;
      height: 48px;
      color: #fff;
      font-size: 20px;
      font-weight: bolder;
      text-align: center;
      margin: 40px auto 10px;
      letter-spacing: 4px;
      background: #116bff;
      border-radius: 8px;
      line-height: 48px;
    }

    .note {
      color: #df1a1a;
      text-align: center;
      font-weight: bolder;
    }
  }
  .contactTitle {
    font-size: 14px;
    span:nth-of-type(2) {
      color: #df1a1a;
    }
  }
}
</style>
